import { jsx as _jsx } from "react/jsx-runtime";
import { SelectField } from "@cinch-labs/design-system";
import styles from "./price.module.css";
import { ANY_PRICE, payFullRange, payMonthlyRange } from "../pay-options";
import { MONTHLY_PRICE, TOTAL_PRICE } from "../handlers";
import { convertIntoRangeFacet } from "./helpers/convert-to-range-facet";
import { fillInMissingRangeFacets } from "./helpers/fill-in-missing-range-facets";
import { getToPriceFacetCountsWhenFromPriceIs } from "./helpers/get-to-price-facet-counts";
import { createLabelWithFacetCount } from "./helpers/create-label-with-facet-count";
import { Datadog } from "@cinch-nx/landing-ui-shared";
const { Actions  } = Datadog;
export const Price = ({ monthlyPriceBucket , priceBucket , radioChecked , maxTotalPrice , setMaxTotalPrice , handleOnChangeTracking  })=>{
    const toPrice = [
        maxTotalPrice.toString()
    ];
    const selectedToPrice = toPrice.length === 0 ? ANY_PRICE : Number(toPrice[0]);
    const selectedFromPrice = ANY_PRICE;
    const useMonthly = radioChecked === MONTHLY_PRICE;
    const priceFacets = convertIntoRangeFacet(fillInMissingRangeFacets(payFullRange, priceBucket));
    const monthlyPriceFacets = convertIntoRangeFacet(fillInMissingRangeFacets(payMonthlyRange, monthlyPriceBucket));
    function onPriceSelected({ setMaxTotalPrice , handleOnChangeTracking , event  }) {
        const value = event.target.value;
        const id = useMonthly ? MONTHLY_PRICE : TOTAL_PRICE;
        const isTotalPrice = id === TOTAL_PRICE;
        const priceType = isTotalPrice ? "total price" : "monthly price";
        const datadogActionName = isTotalPrice ? Actions.SELECT_MAX_PRICE_OPTION : Actions.SELECT_MONTHLY_PRICE_OPTION;
        handleOnChangeTracking({
            trackEventLabel: priceType,
            trackEventAction: "select",
            value,
            datadogActionName
        });
        setMaxTotalPrice(Number.parseInt(value || "0"));
    }
    const getRange = ()=>useMonthly ? payMonthlyRange : payFullRange;
    const toPriceSelectOptions = [
        {
            label: "Any",
            value: ANY_PRICE
        },
        ...getRange().map(({ label , value  })=>({
                label,
                value
            }))
    ];
    const toPriceFacetCounts = getToPriceFacetCountsWhenFromPriceIs(useMonthly ? monthlyPriceFacets : priceFacets);
    const filteredToPriceSelectOptions = toPriceSelectOptions.filter((item)=>{
        if (selectedFromPrice === ANY_PRICE) return true;
        return item.value === ANY_PRICE;
    }).map((item)=>({
            value: item.value,
            label: createLabelWithFacetCount(toPriceFacetCounts, item, selectedToPrice, useMonthly)
        }));
    return /*#__PURE__*/ _jsx(SelectField, {
        label: "Select price",
        labelHidden: true,
        id: "price",
        "data-testid": "price-select",
        options: filteredToPriceSelectOptions,
        placeholder: useMonthly ? "Max monthly budget" : "Max total price",
        placeholderValue: "",
        value: (maxTotalPrice === null || maxTotalPrice === void 0 ? void 0 : maxTotalPrice.toString()) ?? "-1",
        onChange: (event)=>onPriceSelected({
                setMaxTotalPrice: setMaxTotalPrice,
                handleOnChangeTracking,
                event
            }),
        error: {
            show: false,
            classNames: {
                container: styles["errorBox"]
            }
        },
        name: "toPrice",
        classNames: {
            container: styles["toPriceSelect"]
        }
    });
};
